import { render, staticRenderFns } from "./proposal-import-overlay.vue?vue&type=template&id=0a9d31b9&scoped=true&lang=pug"
import script from "./proposal-import-overlay.vue?vue&type=script&lang=js"
export * from "./proposal-import-overlay.vue?vue&type=script&lang=js"
import style0 from "./proposal-import-overlay.vue?vue&type=style&index=0&id=0a9d31b9&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a9d31b9",
  null
  
)

export default component.exports